const getters = {
  token: state => state.user.token,
  krpDom: state => state.krp.krpDom,
  userInfo: state => state.user.userInfo,
  roleList: state => state.user.roleList,
  menus: state => state.user.menus,
  routes: state => state.router.routes,
  routerMenus: state => state.router.routerMenus,
  alreayGeneraterMenus: state => state.router.alreayGeneraterMenus
};
export default getters;
